module.exports = "/assets/e9866e10ec3b44a405b6a1daab2c1b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MN.png
// module id = 2744
// module chunks = 0